<!-- 成功案例内容 -->
<template>
  <div class="container">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="Breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/cases' }"
              >成功案例</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="article" v-if="articleData">
          <h1>{{ articleData.title }}</h1>
          <p>{{ formatTime(articleData.create_time) }}</p>
          <div v-html="articleData.content" class="fuwenben">
            <!-- <img :src="articleData.image" alt="" />
            <h2>{{ articleData.desc }}</h2>
            <li>
              本发明公开了一种无线传感器网络中无人机的轨迹规划方法，该方法将无线传感器网络中多无人机轨迹的设计问题模型化为混合整数非凸优化问题，该方法首先基于聚合算法对传感器节点进行分组，形成多个节点集合，并针对每一节点集合计算无人机访问该节点集合中的传感器节点的访问顺序，并针对每一访问顺序利用凸优化技术计算对应的航迹点，并利用航迹点进行计算得到中心点从而得到新的节点集合.
            </li>
            <div class="littleImg">
              <img src="../assets/CasesDetails_little.png" alt="" />
              <img src="../assets/CasesDetails_little.png" alt="" />
            </div>
            <li>
              本发明公开了一种无线传感器网络中无人机的轨迹规划方法，该方法将无线传感器网络中多无人机轨迹的设计问题模型化为混合整数非凸优化问题，该方法首先基于聚合算法对传感器节点进行分组，形成多个节点集合，并针对每一节点集合计算无人机访问该节点集合中的传感器节点的访问顺序，并针对每一访问顺序利用凸优化技术计算对应的航迹点，并利用航迹点进行计算得到中心点从而得到新的节点集合.
            </li> -->
          </div>
        </div>
        <div class="footer">
          <div class="footer_box left" v-if="articleData.previous">
            <img :src="articleData.previous.image" alt="" />
            <ul>
              <li @click="goToArticle(articleData.previous.id)">
                <i class="el-icon-back"></i>上一篇
              </li>
              <p>{{ articleData.previous.title }}</p>
            </ul>
          </div>
          <div
            class="footer_box left"
            v-else
            style="background-color: transparent"
          ></div>
          <div class="footer_box right" v-if="articleData.next">
            <ul>
              <li @click="goToArticle(articleData.next.id)">
                下一篇<i class="el-icon-right"></i>
              </li>
              <p>{{ articleData.next.title }}</p>
            </ul>
            <img :src="articleData.next.image" alt="" />
          </div>
          <div
            class="footer_box right"
            v-else
            style="background-color: transparent"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExampleDetail } from "../api/userApi";
export default {
  data() {
    return {
      articleData: "",
    };
  },
  async created() {
    // 获取用户信息
    await this.getExampleDetail();
  },
  methods: {
    // 格式化时间
    formatTime(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}.${month}.${day}`;
    },

    async getExampleDetail() {
      try {
        const id = this.$route.query.id;
        console.log(id, "articleId");
        const params = {
          id,
        };
        const response = await getExampleDetail(params);
        console.log(response.data);
        if (response.code === 1) {
          this.articleData = response.data;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    // 跳转到其他文章
    goToArticle(id) {
      // console.log(id, "id");

      this.$router.push(`/casesDetails?id=${id}`);
      // 重新加载数据
      this.getExampleDetail();
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
.main {
  background: #f5f5f5;
  padding-bottom: 45px;
  .Breadcrumb {
    padding: 15px 0;
    ::v-deep .el-breadcrumb__inner {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
    }
  }
  .article {
    padding: 30px;
    background: #ffffff;
    border-radius: 10px;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: #0c1223;
      text-align: left;
    }
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(18, 18, 18, 0.5);
      text-align: left;
      margin-top: 10px;
    }
    img {
      width: 1340px;
      height: 381px;
      margin-top: 15px;
    }
    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #121212;
      text-align: left;
      margin-top: 15px;
    }
    li {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
      text-align: left;
      margin-top: 10px;
    }
    .littleImg {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      img {
        width: 637px;
        height: 366px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    .footer_box {
      margin-top: 20px;
      width: 690px;
      height: 143px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      padding: 25px;
      display: flex;
      align-items: center;
      img {
        width: 139px;
        height: 93px;
      }
      ul {
        li {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 17px;
          color: #175dc2;
          margin-bottom: 21px;
          cursor: pointer;
        }
        p {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 17px;
          color: #333333;
        }
      }
    }
    .left {
      display: flex;
      justify-content: flex-start;
      ul {
        li {
          text-align: left;
          i {
            margin-right: 10px;
          }
        }
      }
      img {
        margin-right: 20px;
      }
    }
    .right {
      display: flex;
      justify-content: flex-end;
      ul {
        li {
          text-align: right;
          i {
            margin-left: 10px;
          }
        }
      }
      img {
        margin-left: 20px;
      }
    }
  }
}
</style>
